import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
// import { getPopmenuInfo } from '@/api/base'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'
import Delivery from "./delivery";
// import ModalView from '@/components/modal-view'
import OpenApp from '../../components/OpenApp';
import { saveAddrInfo, getAddrInfo } from '@/api/user-new'
import { connect } from 'react-redux';
import { Toast } from "antd-mobile";
import h5Share from '@/utils/h5Share'
import Modal from './modal'

import { handleUploadTrace, getObjectFormSerach } from '@/utils'

// import { ModalContainer } from "../sku-exchange/style";
const Active_145 = ({token}) => {
  const active_id =  145;

  const [deliveryVisible, setDeliveryVisible] = useState(false);
  const deliveryRef = useRef('');
  const modelRef = useRef('');
    // const [showAddr,setShowAddr] = useState(false);
  const isStorm = bwmodel.app === 'storm';
  // const shareUrl = `#/active_${active_id}`
  const { source } = getObjectFormSerach(window.location.search);

  let getData = () => {
      const params = {
        activityId: active_id,
      }
       getAddrInfo(params)
          .then(res => {
            if(res.recipientPhone) {
              // setShowAddr(false)
              if (res) {
                deliveryRef.current.setParams(res);
              }
            } else {
              //
              // setShowAddr(true)
            }
            // console.log(res);
          })
  }

  useEffect(() => {
    document.title = '【限量发售】2025年风云财经日历';
    handleUploadTrace('ActivityPagelyuan')

    h5Share.main({
      title: `2025年投资宝典【风云财经日历】`,
      desc: '市值风云独家出品，汇总全年重要财经事件日期，提前布局，做到心中有数。',
      link: process.env.REACT_APP_DEMAND_URL + 'active_'+ active_id,
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();

    getData();

  }, [])



  const handleLeftClick = () => {
    // const bool =  showPopMenu && (count===0);
    // if(bool) {
    //   setShowModal(true);
    // } else {
    //   console.log('返回');
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    // }
  }

  const linkToDownload = () => {
    // 埋点
    // handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

    const handleSubmitAddr = (addr) => {
      const params = {
        activityId: active_id,
        ...addr,
        // giftList: [goodsName1 ,goodsName2]
      }

      saveAddrInfo(params)
      .then(res => {
        Toast.info('地址填写成功')
        setTimeout(()=> {
          // onClose();
          setDeliveryVisible(false);
          // setShowAddr(true);
        }, 1500)

      })
      .catch(err => {
        // onClose();
        console.log(err);
      })
    }

  const handleUnlock = () => {  //
    // if(!showPopMenu) {
    //   return Toast.info('活动已经结束')
    // }
    // 埋点
    if (source === 'mini') {
      /* eslint-disable no-undef */
      wx.miniProgram.navigateTo({url: '/pages/kefu/index'})
      return
    }
    if (!isStorm) {
      linkToDownload()
      return
    }
    if (!token) {
      handleLogin()
      return
    }
    const goods  = {
      skuPrice: 45,
      skuId: 166,
      goodsName: '大鳄周边',  // 此地写死，如复制需要注意
      spuId: '28'     // 此地写死，如复制需要注意
    }



    bridge.callHandler('nativeEvent', {
      event: 'halfScreenPay',
      params: {
        price: `${goods.skuPrice}`,
        activityTitle: goods.goodsName,
        skuId: `${goods.skuId}`,
        orderType: `${goods.spuId}`
      },
    }, (params) => {
      try {
        const info = JSON.parse(params)
        if (info && info.params.result) {
          // initPage()

          // bridge.callHandler('nativeEvent', {event: 'close', params: {
          //   isDelete: false
          // }}, () => {})


          // setShowModal(false);
//
          // 需要地址填写
          // setShowAddr(true);
          // setDeliveryVisible(true);
          // getData();

        }
      } catch (error) {
        //
      }
    })
  }




  function handleScroll(e) {
    // let footer = document.getElementById('footer');

    // if(footer) {
    //   if(window.scrollY >=20) {
    //     footer.classList.add('footer-freeclass-block');
    //   }else {
    //     footer.classList.remove('footer-freeclass-block');
    //   }
    // }

  }



  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
  }, [])

  return (
    <div>
      {
        isStorm && <Header
          title={'【限量发售】2025年风云财经日历'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
           right={
              bwmodel.compareVersion('4.17.9') ?( <img
              onClick={()=> {
                bridge.callHandler('nativeEvent', {
                    event: 'shareLink',
                    params: {
                      // shareLinkParams:{
                      title: `2025年投资宝典【风云财经日历】`,
                      desc: '市值风云独家出品，汇总全年重要财经事件日期，提前布局，做到心中有数。',
                      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_145',
                    }
                  })
              }}
              style={{width:'20px','vertical-align': 'middle'}}
              src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)}
              alt="分享"
            />
              )
          :''
            }
        />
      }

      <Container style={{marginTop: isStorm?'44px':'0px'}}>
       {/* <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" /> */}
        <img className="member-img" src={require('./img/日历1@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历2@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历3@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历4@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历5@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历6@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历7@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历8@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历9@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历11@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历10@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历12@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历13@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历14@2x.png')} alt="市值风云" />
      <div className="footer footer-freeclass-block" id="footer">
      <p class='tips'>市场有风险，投资需谨慎，本内容不构成任何投资建议。</p>
        <div className="btn" onClick={()=>{
           handleUnlock()
        }
          }>
          {/* <div>免费试用7天，解锁全部权益</div>
          <span>原价498元</span> */}
          <div>立即购买(45元)</div>
          <span>原价199元</span>
        </div>

      </div>
        {/* <div className='fixed_box'
          style={{bottom: '180px'}}
          onClick={()=>{
            modelRef.current.setShow(true);
          }}
        >
          <img className="fixed_img"

          src={require('./img/春节发货悬浮球@2x.png')} alt="市值风云" />
        </div> */}
        <div className='fixed_box'
          onClick={()=>{
            setDeliveryVisible(true)
          }}
        >
          <img className="fixed_img" src={require('./img/悬浮球@2x.png')} alt="市值风云" />
        </div>

      </Container>

      {/* <ModalView
        visible={showModal}
        over
        content={
          <ModalContainer >
            <div className="modalCon" onClick={()=>handleUnlock()}>
              <img  src={require('./img/进入弹窗@2x.png')} alt="市值风云" />
              <div className="tips">
                { tips }
                <time>{ tips }</time>
              </div>
            </div>

            <img className="close" onClick={()=>closeModal()} src={closeIcon} alt="市值风云" />

          </ModalContainer>
        }
      /> */}

        <Modal ref={modelRef}/>
          <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={active_id} />

         {
            !isStorm && <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_130`}></OpenApp>
          }
    </div>
  )
}


const Container = styled.div`
  // font-size:0;
  background: #801817;
  padding-bottom:96px;
img {
  vertical-align: middle;
  font-size:0;
  width:100%;
}
 .first {
  //  margin-top: -11vw;
  margin-bottom: -37vw;
 }
  .member-img {
   
    box-sizing: border-box;
    // margin-top: 12px;
  }
    .footer {
      height: 96px;
      background: #801817;
      box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
       padding: 10px 4.1vw 0px;
       position: fixed;
      left: 0;
      right: 0;
      bottom: -126px;
     
      z-index: 10;
      transition: bottom 0.5s;
      &.footer-freeclass-block {
          bottom: 0;
      }
      .tips{
         text-align: center;
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 13px;
        margin-top: 0px;
      }
      .btn {
        height: 44px;
        background: linear-gradient( 270deg, #F3BB6D 0%, #F7E2C3 100%);
        border-radius: 8px;
        font-size: 16px;
        color: #894618;
        text-align: center;
        position: relative;
        line-height: 44px;
        
        >span {
          position: absolute;
          right: 0px;
          width: 70px;
          height: 20px;
          background: #FF3446;
          border-radius: 0px 8px 0px 8px;
          color: #FFFFFF;
          text-decoration: line-through;
          top:0px;
          font-size:12px;
          line-height: 17px;
            
        }
      }
    }
@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}

.fixed_box {
  position: fixed;
  bottom: 120px;
  width: 48px;
  right: 10px;
}
`
// const ModalContainer = styled.div`
//   .modalCon {
//       position: relative;
//       img {
//         width:68.2vw;
//       }

//   }
//   .tips {
//     color: #FFFFFF;
//     position: absolute;
//     width:100%;
//     text-align:center;
//     top: 31vw;
//   }
//   .close {
//     display: block;
//     margin: 10px auto 0;
//   }
// `

// const ModalView =  styled.div`
//   position: fixed;
//   left: 0;
//   top: 0;
//   overflow: hidden;
//   width: 100%;
//   height: 100%;
//   z-index: 1000;
//   display: inline-block;
//   .bg {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0,0,0,0.5);
//     z-index: 10;
//   }
//   .con {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 11;
//   }

// `


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_145))



// WEBPACK FOOTER //
// ./src/views/activity_145/index.js